#import "../fragments/em-from-address-fragment.graphql"

mutation FromAddressCreate($input: FromAddressInput!) {
    fromAddressCreate(input: $input) {
        fromAddress {
            ...FromAddress
        }
    }
}
